import React, { Fragment } from "react"
import { OffersSlider } from "src/components/OffersSlider"
import SEO from "src/components/SEO"
import InViewMonitor from "react-inview-monitor"
import CookiePolicyScript from "src/components/CookiePolicyScript"

const CookiePolicyTemplate: React.FC = () => {
  return (
    <Fragment>
      <SEO title="Cookie Policy" />

      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-8 mt-xl">
            <h1>Cookie Policy</h1>
            <CookiePolicyScript />
          </div>
        </div>
      </div>

      <InViewMonitor classNameNotInView="animate-box" classNameInView="animated fadeInUp">
        <OffersSlider />
      </InViewMonitor>
    </Fragment>
  )
}

export default CookiePolicyTemplate
